import { render, staticRenderFns } from "./OrderProductStoreLink.vue?vue&type=template&id=0b06cb9a&scoped=true&"
import script from "./OrderProductStoreLink.vue?vue&type=script&lang=js&"
export * from "./OrderProductStoreLink.vue?vue&type=script&lang=js&"
import style0 from "./OrderProductStoreLink.vue?vue&type=style&index=0&id=0b06cb9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b06cb9a",
  null
  
)

export default component.exports